import {createAction} from 'redux-act';

import {StepType} from './types';

/**
 * Change step in checkout
 */
export const changeStep = createAction<StepType>('POST_PURCHASE_INSURANCE_CHANGE_STEP');
